export const addValidateRules = (
  rules: Record<string, any> | undefined,
  validate: Record<string, any>,
) => {
  if (rules?.validate) {
    rules.validate = { ...rules.validate, ...validate };
    return rules;
  } else if (rules) {
    rules.validate = validate;
    return rules;
  } else {
    return {
      validate,
    };
  }
};
